import React, { Component } from "react";
import LdsButton from "../components/LdsButton";
import LdsCheckbox from "../components/LdsCheckbox";
import LdsLink from "../components/LdsLink";
import { Formik, Field, Form } from 'formik';

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

const Example = () => (
  <div>
    <h1>Sign Up</h1>
    <Formik
      initialValues={{
        scan: '',
      }}
      onSubmit={async (values) => {
        await sleep(500);
        alert(JSON.stringify(values, null, 2));
      }}
    >
      {({ isSubmitting }) => (
        <Form>
          <fieldset role="radiogroup" className="row">
                    <legend>
                      Is the scan positive or negative?
                    </legend>
                    {/* Answer should change color to green or red depending on correct response. */}
                    <div className="col-sm-12">
                        
                        <input name="scan" type="radio" value="0" checked></input>
                      <label for="positive" className="ps-4 pb-3 green">A. Positive</label>
                    </div>
                    <div className="col-sm-12">
                        <Field type="radio" name="scan" value="1" />
                      <label for="negative" className="ps-4 red">B. Negative</label>
                    </div>
                  </fieldset>

          <button type="submit" disabled={isSubmitting}>
            Submit
          </button>
        </Form>
      )}
    </Formik>
  </div>
);


export default Example;